import React from "react";

const StarBorder = (props) => (
  <svg viewBox="0 0 100 100" {...props}>
    <path d="M100 36.2l-35.95-3.1L50 0 35.95 33.15 0 36.2l27.3 23.65L19.1 95 50 76.35 80.9 95l-8.15-35.15L100 36.2zM50 67L31.2 78.35l5-21.4-16.6-14.4 21.9-1.9L50 20.5l8.55 20.2 21.9 1.9L63.85 57l5 21.4L50 67z" />
  </svg>
);

export default StarBorder;
